import { MapLayerInfo } from '@app/models/data-types/map-layer-info';
import { environment } from '@environments/environment';

export const layersInfo: MapLayerInfo[] = [
	{
		name: 'Mappa dei Limiti Portata',
		modal: {
			header: "Informazioni sull'utilizzo di limiti portata",
			body: "Visualizza per scaglioni, sul reticolo della principale viabilità regionale, la rete transitabile dai mezzi d'opera, dalle macchine operatrici e dai veicoli ad uso speciale di massa complessiva fino a 33, 40, 56, 75 e 100 tonnellate. Le categorie sono visualizzabili singolarmente attraverso la sezione filtri.",
		},
		selected: true,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: '33t', colorHex: '#FF0000' },
			{ label: '40t', colorHex: '#FF6600' },
			{ label: '56t', colorHex: '#FFCC00' },
			{ label: '75t', colorHex: '#779A77' },
			{ label: '100t', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_PORTATA',
				style: 'RERCTA_Viabilita:LIM_PORTATA',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Sagoma',
		modal: {
			header: "Informazioni sull'utilizzo di limiti sagoma",
			body: 'Visualizza per scaglioni, sul reticolo della principale viabilità regionale, la rete con carreggiata di larghezza media maggiore o uguale a 6,00 e 7,00 metri con andamento planimetrico scorrevole.Le categorie sono visualizzabili singolarmente attraverso la sezione filtri.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: '6m', colorHex: '#FFCC00' },
			{ label: '7m', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_SAGOMA',
				style: 'RERCTA_Viabilita:LIM_SAGOMA',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Pali',
		modal: {
			header: "Informazioni sull'utilizzo di limiti pali",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dai mezzi per il trasporto dei pali.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'pali', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_PALI',
				style: 'RERCTA_Viabilita:LIM_BINARY',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Carri',
		modal: {
			header: "Informazioni sull'utilizzo di limiti carri",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dai mezzi per il trasporto dei carri ferroviari.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'carri', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_CARRI',
				style: 'RERCTA_Viabilita:LIM_BINARY',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Agricole',
		modal: {
			header: "Informazioni sull'utilizzo di limiti di macchine agricole",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dalle macchine agricole eccezionali di massa complessiva fino a 44 tonnellate.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'agricole', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_AGRICOLE',
				style: 'RERCTA_Viabilita:LIM_BINARY',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Coils',
		modal: {
			header: "Informazioni sull'utilizzo di limiti coils",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dai mezzi per il trasporto di coils, laminati grezzi e blocchi di pietra naturale di massa complessiva fino a 108 tonnellate.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'coils', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_COILS',
				style: 'RERCTA_Viabilita:LIM_BINARY',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Mo72t',
		modal: {
			header: "Informazioni sull'utilizzo di limiti macchine operatrici 72 t",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dai complessi veicolari per il trasporto di macchine operatrici fino a 72 tonnellate.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'mo72t', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_MO72T',
				style: 'RERCTA_Viabilita:LIM_BINARY',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Prefabbricati',
		modal: {
			header: "Informazioni sull'utilizzo di limiti prefabbricati",
			body: "Visualizza per scaglioni, sul reticolo della principale viabilità regionale, la rete transitabile dai complessi veicolari per il trasporto di elementi prefabbricati compositi ed apparecchiature industriali complesse per l'edilizia con lunghezza fino a 25,00 metri e massa complessiva fino a 75 e 108 tonnellate e con lunghezza fino a 35,00 metri e massa complessiva fino a 108 tonnellate. Le categorie sono visualizzabili singolarmente attraverso la sezione filtri.",
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'pre25x75', colorHex: '#FF0000' },
			{ label: 'pre25x108', colorHex: '#FFCC00' },
			{ label: 'pre35x108', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_PREFABBRICATI',
				style: 'RERCTA_Viabilita:LIM_PREFABBRICATI',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti AgriMR',
		modal: {
			header: "Informazioni sull'utilizzo di limiti di Agricole Mother Regulation",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dai veicoli agricoli e forestali e loro rimorchiati, eccezionali Dir. 2006/26/CE e UE 167/2013 (Mother Regulation) di massa complessiva fino a 58 tonnellate.',
		},
		selected: false,
		legend: [
			{ label: '0', colorHex: '#666666' },
			{ label: 'agriMR', colorHex: '#00E000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_AGRIMR',
				style: 'RERCTA_Viabilita:LIM_BINARY',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa dei Limiti Puntuali',
		modal: {
			header: "Informazioni sull'utilizzo di limiti puntuali",
			body: "Visualizza i principali punti singolari (ponti, gallerie, sottopassi, strettoie, passaggi a livello) associati alle strade dell'ARS e collocati lungo la principale viabilità  extraurbana. Le caratteristiche dei punti singolari sono consultabili ulteriormente attraverso le sezioni degli elenchi e delle mappe tematiche.",
		},
		selected: false,
		legend: [
			{
				label: 'Limite di portata',
				iconPath: `./assets/images/ic_marker_cerchio_nero.png`,
			},
			{
				label: 'Limite di sagoma',
				iconPath: `./assets/images/ic_marker_quadrato_nero.png`,
			},
			{
				label: 'Limite di altezza',
				iconPath: `./assets/images/ic_marker_triangolo_nero.png`,
			},
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_PUNTUALI',
				style: 'RERCTA_Viabilita:LIM_PUNTUALI',
				tiled: false,
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
			'limPuntuali',
		],
	},
	{
		name: 'Dove posso passare?',
		modal: {
			header: "Informazioni sull'utilizzo di 'dove posso passare?'",
			body: 'Visualizza, sul reticolo della principale viabilità regionale, la rete transitabile dalle categorie selezionate nella sezione filtri. Utilizza i filtri limiti di portata, limiti di sagoma e limiti per tipologia in alto per definire le caratteristiche del veicolo.',
		},
		selected: false,
		legend: [
			{ label: 'Transitabile', colorHex: '#00E000' },
			{ label: 'Non Transitabile', colorHex: '#FF0000' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_TRANSITABILE',
				style: 'RERCTA_Viabilita:LIM_TRANSITABILE',
			},
			{
				name: 'RERCTA_Viabilita:LIM_NON_TRANSITABILE',
				style: 'RERCTA_Viabilita:LIM_NON_TRANSITABILE',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
	{
		name: 'Mappa della Classificazione amministrativa',
		modal: {
			header: "Informazioni sull'utilizzo di classificazione amministrativa",
			body: "Visualizza, sul reticolo della principale viabilità regionale, le informazioni di classificazione amministrativa riportate nell'ARS. Le classificazioni sono visualizzabili singolarmente attraverso la sezione filtri.",
		},
		selected: false,
		legend: [
			{ label: 'Autostrada', colorHex: '#000000' },
			{ label: 'Statale', colorHex: '#FF0000' },
			{ label: 'Statale con toponimi comunali', colorHex: '#009900' },
			{ label: 'Provinciale', colorHex: '#FF9900' },
			{ label: 'Provinciale con toponimi comunali', colorHex: '#00CCCC' },
			{ label: 'Comunale', colorHex: '#00E000' },
			{ label: 'Mista', colorHex: '#993300' },
			{ label: 'Vicinale', colorHex: '#0000CC' },
			{ label: 'Privata', colorHex: '#CC00CC' },
			{ label: 'Demaniale', colorHex: '#999999' },
			{ label: 'Non classificata', colorHex: '#FFFF33' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:LIM_CLASS_AMM',
				style: 'RERCTA_Viabilita:LIM_CLASS_AMM',
			},
		],
		visibleFiltersIds: [
			'provinceComuni',
			'province',
			'comuni',
			'classAmm',
			'nomeStrada',
			'numStrada',
			'limPortata',
			'limSagoma',
			'limTipologia',
		],
	},
];
